import React, { forwardRef } from 'react'

import { IconProps } from './types'

const SideBarClose = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      stroke={stroke || 'currentColor'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className={color ? undefined : 'fill-[#787573] dark:fill-[#b6b2b0]'}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2H15V14H1V2ZM2 3V13H5V3H2ZM6 3V13H14V3H6Z"
      />
    </svg>
  ),
)
SideBarClose.displayName = 'SideBarClose'

export default SideBarClose
